import { LoadingIcon } from '@chegg-ui/theme'
import { TOKEN_LOADING_ICON } from '@src/utils/dataTestIds'
import * as React from 'react'
import styled from 'styled-components'

const Main = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`

const Loading: React.FunctionComponent = () => (
  <Main>
    <LoadingIcon size="large" data-test={TOKEN_LOADING_ICON} />
  </Main>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Router/Loading.tsx